import React, { PureComponent } from 'react';
import { CardElement, injectStripe } from 'react-stripe-elements'
import { withFormik } from 'formik';
import {
  FormField,
  FormFieldInput,
  FormFieldLabel,
  FormFieldError,
  FormFieldInline,
  FormFieldButton,
  FormFieldHelp
} from 'react-foundation-components/lib/global/forms';
import { Callout } from 'react-foundation-components/lib/global/callout';
import { Row, Column } from 'react-foundation-components/lib/global/grid';
import Yup from 'yup';
import gbp from 'gbp';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import debounce from 'lodash.debounce';
import AnimateOnChange from 'react-animate-on-change'
import Loading from '../components/Loading';
import config from "../../data/siteConfig";
import amexLogo from '../images/amex.svg';
import mastercardLogo from '../images/mastercard.svg';
import visaLogo from '../images/visa.svg';

function equalTo(ref, msg) {
	return this.test({
		name: 'equalTo',
		exclusive: false,
    message: msg || '${path} must be the same as ${reference}',
		params: {
			reference: ref.path
		},
		test: function(value) {
      return value === this.resolve(ref)
		}
	})
};

Yup.addMethod(Yup.string, 'equalTo', equalTo);

const createOptions = (fontSize) => {
  return {
    style: {
      base: {
        fontSize,
        color: '#424770',
        letterSpacing: '0.025em'
      },
      invalid: {
        color: '#9e2146',
      },
    },
  };
};

class CardForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      cardEntered: false,
      purchaseSuccess: false,
      prevCost: 10000,
      selectedCost: 10000,
    };

    this.calcCost = debounce(this.calcCost, 300);
  }

  componentWillMount() {
    this.calcCost()
  }

  componentWillReceiveProps(nextProps) {
    const { values: { experienceType, quantity} } = this.props;

    this.calcCost()
  }

  handleChange = change => {
    const { setErrors, errors } = this.props
    const { cardEntered } = this.state

    if (change.error && change.error.message) {
      // Set payment error on form object
      setErrors(Object.assign({}, errors, {
        payment: change.error && change.error.message
      }))
    }

    if (change.complete) {
      this.setState({
        cardEntered: change.complete
      });
    }
  }

  calcCost = () => {
    const { values: { experienceType, quantity}, loading, vouchers } = this.props;
    const { prevCost, selectedCost } = this.state;
    if (loading || !vouchers || !Number.isInteger(quantity)) { return }
    const actualQuantity = Number(quantity) === 0 ? 1 : quantity
    const voucher = vouchers.find(voucher => voucher.id == experienceType)
    const basketCost = voucher.price_pence * actualQuantity

    this.setState({
      prevCost: prevCost !== basketCost ? selectedCost : basketCost,
      selectedCost: basketCost
    });
  }

  renderProductFields = (errors, touched) => {
    const { error, loading, vouchers, handleChange, handleBlur, setErrors } = this.props

    if (error) {
      return (
        <FormField error>
          <FormFieldLabel>Experience Type</FormFieldLabel>
          <FormFieldInput name="experienceType" type="select">
            <option disabled>Sorry no experiences loaded</option>
          </FormFieldInput>
          {<FormFieldError>Sorry there has been an error loading experiences. Please refresh the page and try again.</FormFieldError>}
          {<FormFieldError>If the error persists then please <a href={`mailto:${config.siteEmail}`}>contact us</a> for support</FormFieldError>}
        </FormField>
      )
    }

    if (loading) {
      return <Loading props={loading} />
    }

     return(
      <FormField error={errors.experienceType && touched.experienceType}>
        <FormFieldLabel>Experience Type</FormFieldLabel>
        <FormFieldInput name="experienceType" type="select" onChange={handleChange} onBlur={handleBlur}>
          {vouchers.map(({id, name, description, price_pence}) => (
            <option value={id} key={name}>{description} - {gbp(price_pence)}pp</option>
          ))}
        </FormFieldInput>
        {errors.experienceType && touched.experienceType && <FormFieldError>{errors.experienceType}</FormFieldError>}
      </FormField>
     )
  }

  disableSubmit = () => {
    const { isSubmitting, isValid } = this.props
    const { cardEntered } = this.state
    if (cardEntered) { return false }
    if (isValid) { return false }
    return isSubmitting
  }

  objectHasValues = (object) => Object.keys(object).length > 0
  objectHasMatchingKeys = (object1, object2) => {
    const keys1 = Object.keys(object1)
    const keys2 = Object.keys(object2)
    return keys1.some(key => keys2.includes(key))
  }
  renderErrorText = () => {
    const { errors, touched } = this.props

    if (errors.hasOwnProperty('payment') && typeof errors.payment === "undefined") {
      return
    }

    if (this.objectHasValues(errors) && this.objectHasMatchingKeys(errors, touched)) {
      return (
        <Row>
          <Column className="small-12">
            <Callout color="alert">
              <p className="text-center">
                <strong>Please check your details and try again.</strong><br/> If an error persists then please don't hesitate to contact us at <a href={`mailto:${config.siteEmail}`}>{config.siteEmail}</a>
              </p>
            </Callout>
          </Column>
        </Row>
      )
    }
  }

  renderCardErrors = () => {
    const { status, errors} = this.props

    if (this.objectHasValues(errors) && errors.payment && typeof errors.payment !== "undefined") {
      return (
        <FormFieldError className="payment-errors">{errors.payment}</FormFieldError>
      )
    }
  }

  fireAnimation = () => {
    const { prevCost, selectedCost } = this.state;
    return prevCost !== selectedCost
  }

  render() {
    const { cardEntered, prevCost, selectedCost, purchaseSuccess } = this.state;
    const {
      loading,
      vouchers,
      fontSize,
      values,
      touched,
      errors,
      dirty,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      handleReset,
      setStatus,
      status
    } = this.props;
    const animateCost = this.fireAnimation()

    if (status && status.success) {
      const { purchaseData } = status

      return (
        <Row>
          <Column className="small-12">
            <Callout className="text-center" color="success">
              <p><strong>ORDER REF: {purchaseData && purchaseData.orderID}</strong></p>
              <p>Thank you, your payment was sucessful.</p>
              <p>You should receive an invoice to {purchaseData && purchaseData.email} shortly.</p>
            </Callout>
            <button
              className="button expanded success"
              onClick={() => handleReset() }>
              Click here to purchase more experience day vouchers
            </button>
          </Column>
        </Row>
      )
    }
    return (
      <form noValidate onSubmit={handleSubmit}>
        <Row>
          <Column className="small-12">
            <fieldset className="dashed-section">
              <h6>Your contact details</h6>
              <Row>
                <Column className="small-12 medium-6">
                  <FormField error={errors.firstName && touched.firstName}>
                    <FormFieldLabel>First Name</FormFieldLabel>
                    <FormFieldInput name="firstName" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.firstName && touched.firstName && <FormFieldError>{errors.firstName}</FormFieldError>}
                  </FormField>
                </Column>
                <Column className="small-12 medium-6">
                  <FormField error={errors.lastName && touched.lastName}>
                    <FormFieldLabel>Last Name</FormFieldLabel>
                    <FormFieldInput name="lastName" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.lastName && touched.lastName && <FormFieldError>{errors.lastName}</FormFieldError>}
                  </FormField>
                </Column>
              </Row>
              <Row>
                <Column className="small-12 medium-6">
                  <FormField error={errors.email && touched.email}>
                    <FormFieldLabel>Email</FormFieldLabel>
                    <FormFieldInput name="email" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.email && touched.email && <FormFieldError>{errors.email}</FormFieldError>}
                  </FormField>
                </Column>
                <Column className="small-12 medium-6">
                  <FormField error={errors.emailConf && touched.emailConf}>
                    <FormFieldLabel>Email Confirmation</FormFieldLabel>
                    <FormFieldInput name="emailConf" onChange={handleChange} onBlur={handleBlur} required />
                    {errors.emailConf && touched.emailConf && <FormFieldError>{errors.emailConf}</FormFieldError>}
                  </FormField>
                </Column>
              </Row>
            </fieldset>
          </Column>
        </Row>
        <Row>
          <Column className="small-12">
            <fieldset className="dashed-section">
              <h6>Pick your experience day</h6>
              <Row>
                <Column className="small-12 medium-9">
                  {this.renderProductFields(errors, touched)}
                </Column>
                <Column className="small-12 medium-3">
                  <FormField error={errors.quantity && touched.quantity}>
                    <FormFieldLabel>Quantity</FormFieldLabel>
                    <FormFieldInput
                      name="quantity"
                      inputMode="numeric"
                      type="number"
                      pattern="\d*"
                      step="1"
                      min="1"
                      value={values.quantity}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                    />
                    {errors.quantity && touched.quantity && <FormFieldError>{errors.quantity}</FormFieldError>}
                  </FormField>
                </Column>
              </Row>
            </fieldset>
          </Column>
        </Row>
        <Row>
          <Column className="small-12">
            <h6>Your card details</h6>
            <Row>
              <Column className="small-12 medium-9">
                <CardElement
                  className={(this.objectHasValues(errors) && errors.payment && cardEntered) ? 'StripeElement StripeElement--invalid' : 'StripeElement StripeElement--empty'}
                  onChange={this.handleChange}
                  {...createOptions(fontSize)}
                />
                {this.renderCardErrors()}
                <ul className="inline-list">
                  <li>
                    <i className="fa fa-fw fa-2x fa-cc-visa" aria-hidden="true"></i>
                  </li>
                  <li>
                    <i className="fa fa-fw fa-2x fa-cc-mastercard" aria-hidden="true"></i>
                  </li>
                  <li>
                    <i className="fa fa-fw fa-2x fa-cc-amex" aria-hidden="true"></i>
                  </li>
                  <li className='float-right'>
                    <a href="https://stripe.com/gb" target="_blank" rel="noopener">
                      <small>Secure payments powered by </small>
                      <i className="fa fa-fw fa-2x fa-cc-stripe" aria-hidden="true" alt="payments powered by stripe"></i>
                    </a>
                    <i className="fa fa-fw fa-2x fa-lock" aria-hidden="true"></i>
                  </li>
                </ul>
              </Column>
              <Column className="small-12 medium-3">
                <AnimateOnChange
                  baseClassName="animated-element"
                  animationClassName="rubberBand animated"
                  animate={animateCost}>
                  <Callout className="text-center" color="success">
                    <p><strong>Total to pay</strong></p>
                    {gbp(selectedCost)}
                  </Callout>
                </AnimateOnChange>
              </Column>
            </Row>
            {this.renderErrorText()}
            <Row>
              <Column className="small-12">
                <button disabled={isSubmitting} className="button expanded success float-right" type="submit">
                  {
                    isSubmitting ?
                    'Submitting payment...' :
                    status && status.success ?
                      'Payment Succesful' : `Pay ${gbp(selectedCost)}`
                  }
                </button>
              </Column>
            </Row>
          </Column>
        </Row>
      </form>
    )
  }
};

const CardFormWithFormik = withFormik({
  mapPropsToValues: () => ({ firstName: '', lastName: '', email: '', emailConf: '', experienceType: '1', quantity: 1 }),
  validationSchema: Yup.object().shape({
    firstName: Yup.string()
      .required('First name is required'),
    lastName: Yup.string()
      .required('Last name is required'),
    email: Yup.string()
      .email('Invalid email address')
      .required('Email is required'),
    emailConf: Yup.string()
      .equalTo(Yup.ref('email'), 'Email confirmation must be the same as email')
      .email('Invalid email address')
      .required('Email confirmation is required'),
    quantity: Yup.number()
      .transform((currentValue, originalValue) => {
        return (isNaN(currentValue) || currentValue === null || currentValue === 0) ? 0 : originalValue
      })
      .min(1, 'Quantity must be at least 1')
  }),
  handleReset: ({ setStatus }) => {
    setStatus({ success: false })
  },
  handleSubmit: (values, { props, setSubmitting, setErrors, setStatus, resetForm }) => {
    props.stripe
      .createToken({name: `${values.firstName} ${values.lastName}`})
      .then(
        payload => {
          if (payload.error) {
            setErrors({ payment: payload && payload.error.message })
            setSubmitting(false)
            setStatus({ success: false })
          } else {
            // Send the token to your server
            props.mutate({
              variables: {
                purchaseObject: {
                  productId: parseInt(values.experienceType),
                  quantity:  parseInt(values.quantity),
                  firstName: values.firstName,
                  lastName: values.lastName,
                  email: values.email
                },
                token: payload.token.id
              }
            })
              .then(({ data }) => {
                setStatus({
                  success: true,
                  purchaseData: {
                    email: data.purchaseProduct.email,
                    orderID: data.purchaseProduct.order_id
                  }
                });
                setSubmitting(false)
              }).catch((error) => {
                console.log('there was an error sending the query', error,  error && error.graphQLErrors.map(x => x.message));
                const stripeErrors = error && error.graphQLErrors.map(x => x.message)
                setErrors({ payment: stripeErrors })
                setSubmitting(false)
                setStatus({ success: false })
              });
          }
        }
      )
  },
  // validateOnBlur: true,
  // validateOnChange: true,
  displayName: 'CardForm', // helps with React DevTools
})(CardForm);

const purchaseProduct = gql`
  mutation purchaseProduct($purchaseObject: PurchaseInputType, $token: String!) {
    purchaseProduct(purchase: $purchaseObject, token: $token) {
      email
      name
      price_pence
      order_id
   }
 }
`;

const InjectedCardForm = injectStripe(CardFormWithFormik)
const CardFormWithGraphql = graphql(purchaseProduct)(InjectedCardForm);

export default CardFormWithGraphql


// WEBPACK FOOTER //
// ./src/components/CardForm.js